import React, { useState, ReactElement, useEffect } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
  MessageContainer,
  Icon,
  Title,
  Subtitle
} from "./ctepLoad.styled"
import {ReactComponent as LoadingIcon} from "assets/images/loading_icon.svg";


function CTEPLoad(props) {

    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');

    const nextButtonClick = () => {
        props.onNextButtonClick();
    }

      useEffect(() => {
        props.pageNum === 2 ? setTitle('Generating Questionaire') : setTitle('Generating Report');
        props.pageNum === 2 ? setSubtitle('This may take up to 3 min, we advice you to wait for the questionaire to generate') : 
                              setSubtitle('This may take up to 3 min, we advice you to wait for the report to generate');
      }, []);

    return (

        <MessageContainer>
          <Icon>
            <LoadingIcon></LoadingIcon>
          </Icon>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {props.errorThrown === true ? <div>An error has occured, please try again</div> : <div></div>}
        </MessageContainer>




    );
}

export default CTEPLoad;